const getSystemInfo = () => {
  const u = navigator.userAgent
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 是否为ios设备
  const isPC = typeof window.orientation === 'undefined' // 是否为PC端
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 是否为android端
  const isWx = u.toLocaleLowerCase().indexOf('micromessenger') > -1 // 判断是否为微信浏览器
  const isPhoneX = /iphone/gi.test(navigator.userAgent) && screen.height >= 812 && screen.width >= 375
  const os = {
    ios: isIOS,
    pc: isPC,
    android: isAndroid,
    isWx: isWx,
    isPhoneX: isPhoneX
  }
  return os
}

export default getSystemInfo
